// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { ChangeEvent, useLayoutEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import S from './styles';
import ImageIcon from '../assets/image_icon.svg';
import CrossIcon from '../assets/cross-image.svg';

interface ImageUpload {
  urls: string;
  file: File;
}

interface Props extends React.ComponentPropsWithRef<any> {
  message: string;
  placeholder: string;
  isLoading: boolean;
  onChange?: React.ChangeEventHandler;
  onBlur?: React.FocusEventHandler;
  onSubmit?: React.FormEventHandler;
  listImagePreviewUrls: ImageUpload[];
  setListImagePreviewUrl: (value: React.SetStateAction<ImageUpload[]>) => void;
  disabled: boolean;
  inline?: boolean;
}

const ReplyField: React.FC<Props> = ({
  message,
  placeholder,
  isLoading,
  onChange,
  onBlur,
  onSubmit,
  listImagePreviewUrls,
  setListImagePreviewUrl,
  disabled,
  inline,
  ...props
}) => {
  const intl = useIntl();
  const [tooltipPos, setTooltipPos] = useState<{ left: string; top: string }>();
  const [tooltipText, setTooltipText] = useState('');
  const inputFileRef = useRef<HTMLInputElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    if (!textareaRef.current) return;
    textareaRef.current.style.height = 'auto';
    textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'
  }, [message, listImagePreviewUrls.length === 0]);

  const onImageBtnClick = () => {
    inputFileRef.current?.click();
  };

  const onDeleteBtnClick = (url: string) => {
    const newList = listImagePreviewUrls.filter(data => data.urls !== url);
    setListImagePreviewUrl(newList)
    setTooltipPos(undefined);
  };
  const imagePreview = (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const url = reader.result as string;
      console.log(url)
      setListImagePreviewUrl(data => [...data, { urls: url, file }])
    };
  }
  const handleChangeImage = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) {
      const files = e.target.files;
      console.log({ files })
      for (let i = 0; i < files.length; i++) {
        imagePreview(files[i])
      }
    }
  }

  const handleMouseEnter = (e: React.MouseEvent<HTMLImageElement, MouseEvent>, message: string) => {
    const { x, y, width } = e.currentTarget.getBoundingClientRect();
    setTooltipPos({ left: (x + width / 2) + 'px', top: y + 'px' })
    setTooltipText(message)
  }
  const handleMouseLeave = () => {
    setTooltipPos(undefined);
  }

  const renderTextarea = () => {
    return (
      <S.Textarea
        disabled={isLoading}
        ref={textareaRef}
        name="message"
        value={message}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        rows={1} /* Prevent height = 2 * line-height bugs */
        maxLength={1000}
        inline={inline}
      />
    )
  }

  const renderImageUploadWrapper = () => {
    if (listImagePreviewUrls.length === 0) {
      return;
    }
    return (
      <S.ImageUploadWrapper>
        {listImagePreviewUrls.map(data => (
          <S.ImageContainer key={data.urls}>
            <S.ImageUploadItem src={data.urls} />
            <S.CrossIcon
              onClick={() => !isLoading && onDeleteBtnClick(data.urls)}
              onMouseEnter={(e) => !isLoading && handleMouseEnter(e, intl.formatMessage({ id: 'I023' }))}
              onMouseLeave={() => !isLoading && handleMouseLeave()}
              src={CrossIcon}
            />
          </S.ImageContainer>
        ))}
      </S.ImageUploadWrapper>
    )
  }

  const renderButtonWrapper = () => {
    return (
      <S.ButtonWrapper>
        <S.ImageBtn
          onClick={(!isLoading) ? onImageBtnClick : undefined}
          onMouseEnter={(e) => !isLoading && handleMouseEnter(e, intl.formatMessage({ id: 'I014' }))}
          onMouseLeave={() => !isLoading && handleMouseLeave()}
          src={ImageIcon}
        />
        <S.TextCountWrapper>
          {message.length > 500 && <S.TextCount>{message.length}/1000</S.TextCount>}
          <S.Btn type="submit" disabled={disabled} isLoading={isLoading} onClick={onSubmit}>
            {isLoading ? (<S.LoadingIcon size={5} />) : intl.formatMessage({ id: 'I012' })}
          </S.Btn>
        </S.TextCountWrapper>
      </S.ButtonWrapper>
    )
  }

  const renderTooltip = () => {
    if (!tooltipPos)
      return;

    return (
      <S.Tooltip style={tooltipPos}>
        {tooltipText}
      </S.Tooltip>
    )
  }

  if (inline) {
    return (
      <S.InlineWrapper {...props}>
        <S.InlineMessageWrapper>
          {renderTextarea()}
          {renderImageUploadWrapper()}
        </S.InlineMessageWrapper>
        {renderButtonWrapper()}

        {renderTooltip()}
        <S.FileInput
          name="image"
          onChange={handleChangeImage}
          ref={inputFileRef}
        />
      </S.InlineWrapper>
    )
  }

  return (
    <S.MessageFieldWrapper {...props}>
      {renderTextarea()}
      <S.BottomWrapper>
        {renderImageUploadWrapper()}
        {renderButtonWrapper()}
      </S.BottomWrapper>
      {renderTooltip()}
      <S.FileInput
        name="image"
        onChange={handleChangeImage}
        ref={inputFileRef}
      />
    </S.MessageFieldWrapper>
  )
}

export { ReplyField as default };
